export default function (store, scroll) {
    store.setState({
        scroll,
    });
}
//# sourceMappingURL=scroll.js.map